// src/constants/paises.ts

export const paisesOptions = [
  { value: "Alemania", label: "Alemania" },
  { value: "Austria", label: "Austria" },
  { value: "Bélgica", label: "Bélgica" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Chequia", label: "Chequia" },
  { value: "Chipre", label: "Chipre" },
  { value: "Croacia", label: "Croacia" },
  { value: "Dinamarca", label: "Dinamarca" },
  { value: "Eslovaquia", label: "Eslovaquia" },
  { value: "Eslovenia", label: "Eslovenia" },
  { value: "España", label: "España" },
  { value: "Estonia", label: "Estonia" },
  { value: "Finlandia", label: "Finlandia" },
  { value: "Francia", label: "Francia" },
  { value: "Grecia", label: "Grecia" },
  { value: "Hungría", label: "Hungría" },
  { value: "Irlanda", label: "Irlanda" },
  { value: "Islandia", label: "Islandia" },
  { value: "Italia", label: "Italia" },
  { value: "Letonia", label: "Letonia" },
  { value: "Lituania", label: "Lituania" },
  { value: "Luxemburgo", label: "Luxemburgo" },
  { value: "Malta", label: "Malta" },
  { value: "Noruega", label: "Noruega" },
  { value: "Países Bajos", label: "Países Bajos" },
  { value: "Polonia", label: "Polonia" },
  { value: "Portugal", label: "Portugal" },
  { value: "Reino Unido", label: "Reino Unido" },
  { value: "Rumanía", label: "Rumanía" },
  { value: "Suecia", label: "Suecia" },
  { value: "Suiza", label: "Suiza" },
];
